/**
 * イベント状態管理設定
 * 
 * このファイルを編集することで、イベントの状態を一括で切り替えできます。
 * 
 * @type {boolean} isEventEnded - イベントが終了しているかどうか
 *   - true: イベント終了（購入ボタン非表示、終了告知表示）
 *   - false: イベント開催中（通常表示）
 */
export const isEventEnded = true;

